import type { JSX } from 'react';

type LazyFlagModule = Promise<{ default: () => JSX.Element }>;

export const flags = {
  ad: async (): LazyFlagModule => import('./ad'),
  ae: async (): LazyFlagModule => import('./ae'),
  af: async (): LazyFlagModule => import('./af'),
  ag: async (): LazyFlagModule => import('./ag'),
  ai: async (): LazyFlagModule => import('./ai'),
  al: async (): LazyFlagModule => import('./al'),
  am: async (): LazyFlagModule => import('./am'),
  ao: async (): LazyFlagModule => import('./ao'),
  ar: async (): LazyFlagModule => import('./ar'),
  as: async (): LazyFlagModule => import('./as'),
  at: async (): LazyFlagModule => import('./at'),
  au: async (): LazyFlagModule => import('./au'),
  aw: async (): LazyFlagModule => import('./aw'),
  ax: async (): LazyFlagModule => import('./ax'),
  az: async (): LazyFlagModule => import('./az'),
  ba: async (): LazyFlagModule => import('./ba'),
  bb: async (): LazyFlagModule => import('./bb'),
  bd: async (): LazyFlagModule => import('./bd'),
  be: async (): LazyFlagModule => import('./be'),
  bf: async (): LazyFlagModule => import('./bf'),
  bg: async (): LazyFlagModule => import('./bg'),
  bh: async (): LazyFlagModule => import('./bh'),
  bi: async (): LazyFlagModule => import('./bi'),
  bj: async (): LazyFlagModule => import('./bj'),
  bl: async (): LazyFlagModule => import('./bl'),
  bm: async (): LazyFlagModule => import('./bm'),
  bn: async (): LazyFlagModule => import('./bn'),
  bo: async (): LazyFlagModule => import('./bo'),
  'bq-1': async (): LazyFlagModule => import('./bq-1'),
  'bq-2': async (): LazyFlagModule => import('./bq-2'),
  bq: async (): LazyFlagModule => import('./bq'),
  br: async (): LazyFlagModule => import('./br'),
  bs: async (): LazyFlagModule => import('./bs'),
  bt: async (): LazyFlagModule => import('./bt'),
  bw: async (): LazyFlagModule => import('./bw'),
  by: async (): LazyFlagModule => import('./by'),
  bz: async (): LazyFlagModule => import('./bz'),
  ca: async (): LazyFlagModule => import('./ca'),
  cc: async (): LazyFlagModule => import('./cc'),
  cd: async (): LazyFlagModule => import('./cd'),
  'cd-1': async (): LazyFlagModule => import('./cd-1'),
  cf: async (): LazyFlagModule => import('./cf'),
  cg: async (): LazyFlagModule => import('./cg'),
  ch: async (): LazyFlagModule => import('./ch'),
  ck: async (): LazyFlagModule => import('./ck'),
  cl: async (): LazyFlagModule => import('./cl'),
  cm: async (): LazyFlagModule => import('./cm'),
  cn: async (): LazyFlagModule => import('./cn'),
  co: async (): LazyFlagModule => import('./co'),
  cr: async (): LazyFlagModule => import('./cr'),
  cu: async (): LazyFlagModule => import('./cu'),
  cv: async (): LazyFlagModule => import('./cv'),
  cw: async (): LazyFlagModule => import('./cw'),
  cx: async (): LazyFlagModule => import('./cx'),
  cy: async (): LazyFlagModule => import('./cy'),
  cz: async (): LazyFlagModule => import('./cz'),
  de: async (): LazyFlagModule => import('./de'),
  dj: async (): LazyFlagModule => import('./dj'),
  dk: async (): LazyFlagModule => import('./dk'),
  dm: async (): LazyFlagModule => import('./dm'),
  do: async (): LazyFlagModule => import('./do'),
  ds: async (): LazyFlagModule => import('./ds'),
  dz: async (): LazyFlagModule => import('./dz'),
  ec: async (): LazyFlagModule => import('./ec'),
  ee: async (): LazyFlagModule => import('./ee'),
  eg: async (): LazyFlagModule => import('./eg'),
  eh: async (): LazyFlagModule => import('./eh'),
  er: async (): LazyFlagModule => import('./er'),
  es: async (): LazyFlagModule => import('./es'),
  eu: async (): LazyFlagModule => import('./eu'),
  et: async (): LazyFlagModule => import('./et'),
  fi: async (): LazyFlagModule => import('./fi'),
  fj: async (): LazyFlagModule => import('./fj'),
  fk: async (): LazyFlagModule => import('./fk'),
  fm: async (): LazyFlagModule => import('./fm'),
  fo: async (): LazyFlagModule => import('./fo'),
  fr: async (): LazyFlagModule => import('./fr'),
  ga: async (): LazyFlagModule => import('./ga'),
  gb: async (): LazyFlagModule => import('./gb'),
  'gb-2': async (): LazyFlagModule => import('./gb-2'),
  gd: async (): LazyFlagModule => import('./gd'),
  ge: async (): LazyFlagModule => import('./ge'),
  gf: async (): LazyFlagModule => import('./gf'),
  gg: async (): LazyFlagModule => import('./gg'),
  gh: async (): LazyFlagModule => import('./gh'),
  gi: async (): LazyFlagModule => import('./gi'),
  gl: async (): LazyFlagModule => import('./gl'),
  gm: async (): LazyFlagModule => import('./gm'),
  gn: async (): LazyFlagModule => import('./gn'),
  gp: async (): LazyFlagModule => import('./gp'),
  gq: async (): LazyFlagModule => import('./gq'),
  gr: async (): LazyFlagModule => import('./gr'),
  gt: async (): LazyFlagModule => import('./gt'),
  gu: async (): LazyFlagModule => import('./gu'),
  gw: async (): LazyFlagModule => import('./gw'),
  gy: async (): LazyFlagModule => import('./gy'),
  hk: async (): LazyFlagModule => import('./hk'),
  hn: async (): LazyFlagModule => import('./hn'),
  hr: async (): LazyFlagModule => import('./hr'),
  ht: async (): LazyFlagModule => import('./ht'),
  hu: async (): LazyFlagModule => import('./hu'),
  id: async (): LazyFlagModule => import('./id'),
  ie: async (): LazyFlagModule => import('./ie'),
  il: async (): LazyFlagModule => import('./il'),
  im: async (): LazyFlagModule => import('./im'),
  in: async (): LazyFlagModule => import('./in'),
  io: async (): LazyFlagModule => import('./io'),
  iq: async (): LazyFlagModule => import('./iq'),
  ir: async (): LazyFlagModule => import('./ir'),
  is: async (): LazyFlagModule => import('./is'),
  it: async (): LazyFlagModule => import('./it'),
  je: async (): LazyFlagModule => import('./je'),
  jm: async (): LazyFlagModule => import('./jm'),
  jo: async (): LazyFlagModule => import('./jo'),
  jp: async (): LazyFlagModule => import('./jp'),
  ke: async (): LazyFlagModule => import('./ke'),
  kg: async (): LazyFlagModule => import('./kg'),
  kh: async (): LazyFlagModule => import('./kh'),
  ki: async (): LazyFlagModule => import('./ki'),
  km: async (): LazyFlagModule => import('./km'),
  kn: async (): LazyFlagModule => import('./kn'),
  kp: async (): LazyFlagModule => import('./kp'),
  kr: async (): LazyFlagModule => import('./kr'),
  kw: async (): LazyFlagModule => import('./kw'),
  ky: async (): LazyFlagModule => import('./ky'),
  kz: async (): LazyFlagModule => import('./kz'),
  la: async (): LazyFlagModule => import('./la'),
  lb: async (): LazyFlagModule => import('./lb'),
  lc: async (): LazyFlagModule => import('./lc'),
  li: async (): LazyFlagModule => import('./li'),
  lk: async (): LazyFlagModule => import('./lk'),
  lr: async (): LazyFlagModule => import('./lr'),
  ls: async (): LazyFlagModule => import('./ls'),
  lt: async (): LazyFlagModule => import('./lt'),
  lu: async (): LazyFlagModule => import('./lu'),
  lv: async (): LazyFlagModule => import('./lv'),
  ly: async (): LazyFlagModule => import('./ly'),
  ma: async (): LazyFlagModule => import('./ma'),
  mc: async (): LazyFlagModule => import('./mc'),
  md: async (): LazyFlagModule => import('./md'),
  me: async (): LazyFlagModule => import('./me'),
  mg: async (): LazyFlagModule => import('./mg'),
  mh: async (): LazyFlagModule => import('./mh'),
  mk: async (): LazyFlagModule => import('./mk'),
  ml: async (): LazyFlagModule => import('./ml'),
  mm: async (): LazyFlagModule => import('./mm'),
  mn: async (): LazyFlagModule => import('./mn'),
  mo: async (): LazyFlagModule => import('./mo'),
  mp: async (): LazyFlagModule => import('./mp'),
  mq: async (): LazyFlagModule => import('./mq'),
  mr: async (): LazyFlagModule => import('./mr'),
  ms: async (): LazyFlagModule => import('./ms'),
  mt: async (): LazyFlagModule => import('./mt'),
  mu: async (): LazyFlagModule => import('./mu'),
  mv: async (): LazyFlagModule => import('./mv'),
  mw: async (): LazyFlagModule => import('./mw'),
  mx: async (): LazyFlagModule => import('./mx'),
  my: async (): LazyFlagModule => import('./my'),
  mz: async (): LazyFlagModule => import('./mz'),
  na: async (): LazyFlagModule => import('./na'),
  nc: async (): LazyFlagModule => import('./nc'),
  ne: async (): LazyFlagModule => import('./ne'),
  nf: async (): LazyFlagModule => import('./nf'),
  ng: async (): LazyFlagModule => import('./ng'),
  ni: async (): LazyFlagModule => import('./ni'),
  nl: async (): LazyFlagModule => import('./nl'),
  no: async (): LazyFlagModule => import('./no'),
  np: async (): LazyFlagModule => import('./np'),
  nr: async (): LazyFlagModule => import('./nr'),
  nu: async (): LazyFlagModule => import('./nu'),
  nz: async (): LazyFlagModule => import('./nz'),
  om: async (): LazyFlagModule => import('./om'),
  pa: async (): LazyFlagModule => import('./pa'),
  pe: async (): LazyFlagModule => import('./pe'),
  pf: async (): LazyFlagModule => import('./pf'),
  pg: async (): LazyFlagModule => import('./pg'),
  ph: async (): LazyFlagModule => import('./ph'),
  pk: async (): LazyFlagModule => import('./pk'),
  pl: async (): LazyFlagModule => import('./pl'),
  pn: async (): LazyFlagModule => import('./pn'),
  pr: async (): LazyFlagModule => import('./pr'),
  ps: async (): LazyFlagModule => import('./ps'),
  pt: async (): LazyFlagModule => import('./pt'),
  pw: async (): LazyFlagModule => import('./pw'),
  py: async (): LazyFlagModule => import('./py'),
  qa: async (): LazyFlagModule => import('./qa'),
  re: async (): LazyFlagModule => import('./re'),
  ro: async (): LazyFlagModule => import('./ro'),
  rs: async (): LazyFlagModule => import('./rs'),
  ru: async (): LazyFlagModule => import('./ru'),
  rw: async (): LazyFlagModule => import('./rw'),
  sa: async (): LazyFlagModule => import('./sa'),
  sb: async (): LazyFlagModule => import('./sb'),
  sc: async (): LazyFlagModule => import('./sc'),
  sd: async (): LazyFlagModule => import('./sd'),
  se: async (): LazyFlagModule => import('./se'),
  sg: async (): LazyFlagModule => import('./sg'),
  si: async (): LazyFlagModule => import('./si'),
  sk: async (): LazyFlagModule => import('./sk'),
  sl: async (): LazyFlagModule => import('./sl'),
  sm: async (): LazyFlagModule => import('./sm'),
  sn: async (): LazyFlagModule => import('./sn'),
  so: async (): LazyFlagModule => import('./so'),
  sr: async (): LazyFlagModule => import('./sr'),
  ss: async (): LazyFlagModule => import('./ss'),
  st: async (): LazyFlagModule => import('./st'),
  sv: async (): LazyFlagModule => import('./sv'),
  sx: async (): LazyFlagModule => import('./sx'),
  sy: async (): LazyFlagModule => import('./sy'),
  sz: async (): LazyFlagModule => import('./sz'),
  tc: async (): LazyFlagModule => import('./tc'),
  td: async (): LazyFlagModule => import('./td'),
  tg: async (): LazyFlagModule => import('./tg'),
  th: async (): LazyFlagModule => import('./th'),
  tj: async (): LazyFlagModule => import('./tj'),
  tk: async (): LazyFlagModule => import('./tk'),
  tl: async (): LazyFlagModule => import('./tl'),
  tm: async (): LazyFlagModule => import('./tm'),
  tn: async (): LazyFlagModule => import('./tn'),
  to: async (): LazyFlagModule => import('./to'),
  tr: async (): LazyFlagModule => import('./tr'),
  tt: async (): LazyFlagModule => import('./tt'),
  tv: async (): LazyFlagModule => import('./tv'),
  tw: async (): LazyFlagModule => import('./tw'),
  tz: async (): LazyFlagModule => import('./tz'),
  ua: async (): LazyFlagModule => import('./ua'),
  ug: async (): LazyFlagModule => import('./ug'),
  us: async (): LazyFlagModule => import('./us'),
  uy: async (): LazyFlagModule => import('./uy'),
  uz: async (): LazyFlagModule => import('./uz'),
  va: async (): LazyFlagModule => import('./va'),
  vc: async (): LazyFlagModule => import('./vc'),
  ve: async (): LazyFlagModule => import('./ve'),
  vg: async (): LazyFlagModule => import('./vg'),
  vi: async (): LazyFlagModule => import('./vi'),
  vn: async (): LazyFlagModule => import('./vn'),
  vu: async (): LazyFlagModule => import('./vu'),
  ws: async (): LazyFlagModule => import('./ws'),
  xk: async (): LazyFlagModule => import('./xk'),
  ye: async (): LazyFlagModule => import('./ye'),
  za: async (): LazyFlagModule => import('./za'),
  zm: async (): LazyFlagModule => import('./zm'),
  zw: async (): LazyFlagModule => import('./zw'),
};
